import React, { useState } from 'react';
import { motion } from 'motion/react';
import { DEMO_SECTORS } from '../constants';
import DisplayRotativa from './DisplayRotativa';

export const ShowcaseDisplay = () => {
  const [activeSector, setActiveSector] = useState(DEMO_SECTORS[0]);

  return (
    <div className="w-full max-w-7xl mx-auto py-20 px-6">
      <h2 className="text-4xl font-light tracking-tighter mb-12 text-center text-white">Explora el Ecosistema</h2>
      
      {/* Selector */}
      <div className="flex flex-wrap justify-center gap-4 mb-10">
        {DEMO_SECTORS.map((sector) => (
          <button
            key={sector.id}
            onClick={() => setActiveSector(sector)}
            className={`px-6 py-3 rounded-full transition-all text-sm font-medium ${
              activeSector.id === sector.id 
                ? 'bg-yellow-500 text-black' 
                : 'bg-neutral-800 text-neutral-400 hover:bg-neutral-700'
            }`}
          >
            {sector.label}
          </button>
        ))}
      </div>

      {/* Showcase */}
      <motion.div 
        key={activeSector.id}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full aspect-video rounded-3xl overflow-hidden border border-neutral-800 shadow-2xl bg-black"
      >
        {(activeSector as any).isReal ? (
            <iframe src={activeSector.url} className="w-full h-full border-0" title={`Aura Display - ${activeSector.label}`} allowFullScreen />
        ) : (
            <DisplayRotativa mockData={activeSector.data} />
        )}
      </motion.div>
    </div>
  );
};

